import { RoleEnum } from "types/enums";

export type TenantRoleGroup = "Admin" | "Advertiser" | "AffiliatePartner";

const ADMIN_ROLES: RoleEnum[] = [
    RoleEnum.AdminBeast,
    RoleEnum.AdminPro,
    RoleEnum.AdminPlus,
    RoleEnum.AdminLite,
    RoleEnum.AdminFree,
];
const ADVERTISER_ROLES: RoleEnum[] = [
    RoleEnum.AdvertiserPro,
    RoleEnum.AdvertiserPlus,
    RoleEnum.Advertiser,
    RoleEnum.AdvertiserExtra,
];
const AFFILIATE_ROLES: RoleEnum[] = [RoleEnum.AffiliatePartner, RoleEnum.AffiliateManager];

// Order matters: a tenant member can hold several roles, so the highest-ranking group wins.
const ROLE_GROUP_COLORS: Record<TenantRoleGroup, string> = {
    Admin: "#9254DE",
    Advertiser: "#40A9FF",
    AffiliatePartner: "#73D13D",
};

// Order matters: this defines the priority (highest first) used when only one group is wanted.
const ROLE_GROUP_MATCHERS: Array<{ group: TenantRoleGroup; roles: RoleEnum[] }> = [
    { group: "Admin", roles: ADMIN_ROLES },
    { group: "Advertiser", roles: ADVERTISER_ROLES },
    { group: "AffiliatePartner", roles: AFFILIATE_ROLES },
];

// A tenant member can hold several roles at once (e.g. Admin and Affiliate) — returns every
// distinct group present, highest-priority first, so callers can render all of them.
export const getTenantRoleGroups = (roleNames: RoleEnum[] = []): TenantRoleGroup[] =>
    ROLE_GROUP_MATCHERS.filter(({ roles }) => roleNames.some((role) => roles.includes(role))).map(({ group }) => group);

export const getHighestTenantRoleGroup = (roleNames: RoleEnum[] = []): TenantRoleGroup | null =>
    getTenantRoleGroups(roleNames)[0] ?? null;

export const getTenantRoleBadgeColor = (group: TenantRoleGroup): string => ROLE_GROUP_COLORS[group];
